module.exports = __webpack_public_path__ + "labioplastika_3_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/labioplastika_3_before_tn.jpg
// module id = 1540
// module chunks = 0